<template>
  <div>
    <b-row align-h="between" class="mb-3">
      <b-col cols="6">
        <b-button-group size="md">
          <b-button class="mr-2" variant="outline-success" @click="fromLoad('add')" v-if="allow('A')">
            <b-icon-plus></b-icon-plus>
            {{$l('tips_add') || '新增属性'}}
          </b-button>
        </b-button-group>
      </b-col>
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group>
            <b-form-input @keyup.enter="query" v-model="form.searchKey" type="search" placeholder="Search here..."/>
            <b-input-group-append>
              <b-button-group>
                <b-button @click="query" variant="primary" class="my-2 my-sm-0">
                  <i class="fa fa-search"></i>
                </b-button>
                <b-dropdown right variant="light" ref="dropdown">
                  <b-dd-form :inline="true" style="width: 400px;">
                    <b-form-row class="mb-2">
                      <b-col md="12" lg="12">
                        <b-form-group :label="$l('search_label_master_category')||'主分类'">
                          <dict-select v-model="form.masterCategoryCode" clearable filterable
                                       url="/digitalCenter/common/dict/masterCategory"
                                        style="width: 100%;">
                          </dict-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col style="text-align:center;">
                        <b-button block variant="primary" @click="query">Search</b-button>
                        <b-button block variant="outline-primary" @click="onReset">Reset</b-button>
                      </b-col>
                    </b-form-row>
                  </b-dd-form>
                </b-dropdown>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      masterCategoryList: [],
      categoryList: [],
      form: {
        searchKey: '',
        masterCategoryCode: '',
        categoryCode: '',
        resInputColumnType: []
      }
    }
  },
  methods: {
    assign (val) {
      this.form.masterCategoryCode = val.masterCategoryCode
    },
    onReset(){
      this.form = {
        searchKey: '',
        masterCategoryCode: '',
        categoryCode: '',
      }
      this.$emit('reset')
      this.$emit("loadCategoryData")
      this.query()
    },
    fromLoad(val){
      this.$emit(val)
    },
    query () {
      this.$emit('submit', this.form)
    },
    categorySelect (parentCode) {
      this.form.categoryCode = ''
      if (parentCode) {
        this.$api.masterCategory({ parentCode })
          .then(res => {
            this.categoryList = res.body.data
          })
      }
    }
  },
  created () {
    this.onReset()
  },
  activated () {
    this.onReset()
  }
}
</script>
